export const LOG_IN_DISPLAY_TEXT = {
    buttonDisplayText: 'Login',
};

export const ssoSplunkActions = {
    loginWithSsoLink: 'login-with-sso-link',
    loginWithSsoPageViewed: 'login-with-sso-page-viewed',
    loginWithSsoLoginClick: 'login-with-sso-login-click',
    loginWithSsoSuccess: 'login-with-sso-success',
    forceSsoSuccess: 'force-sso-success',
    forceSsoViewed: 'force-sso-viewed',
    ssoEmailNotAssociatedError: 'sso-email-not-associated-error',
    signupWithSsoLink: 'signup-with-sso-link',
    signupWithSsoPageViewed: 'signup-with-sso-page-viewed',
    signupWithSsoSuccess: 'signup-with-sso-success',
    signupWithSsoSignupClick: 'signup-with-sso-signup-click',
};

export const SSO_SIGNUP_ROUTE = '/auth/signup-sso';
export const SSO_LOGIN_ROUTE = '/auth/signin-sso';
